import React from 'react'
import About from './About'
import Navbar from './Navbar'
import Skills from './Skills'
import Project from './Project'
import Footer from './Footer'
import Contact from './Contact'

const Home = () => {
  return (
    <>
      <Navbar />
      <About />
      <Skills />
      <Project />
      <Contact/>
      <Footer />
    </>
  )
}

export default Home